

import html5Logo from "../imgs/technologies/html.png";
import cssLogo from "../imgs/technologies/css.png";
import cSharpLogo from "../imgs/technologies/csharp.png"
import jsLogo from "../imgs/technologies/js.png"
import reactLogo from "../imgs/technologies/react.png"
import salesforceLogo from "../imgs/technologies/salesforce.png"
import gitLogo from "../imgs/technologies/git.png";

import vscode from "../imgs/tools/vscode.png";
import bitbucket from "../imgs/tools/bitbucket.png";
import azuredevops from "../imgs/tools/azuredevops.png";
import confluence from "../imgs/tools/confluence.png";
import jira from "../imgs/tools/jira.png";
import gitlab from "../imgs/tools/gitlab.png";
import copado from "../imgs/tools/copado.png";
import github from "../imgs/tools/github.png";
import node from "../imgs/tools/node.png";

export const icons = [
    {
        type: "technology",
        id: "html",
        name: "HTML",
        path: html5Logo
    },
    {
        type: "technology",
        id: "css",
        name: "CSS",
        path: cssLogo
    },
    {
        type: "technology",
        id: "csharp",
        name: "C#",
        path: cSharpLogo
    },
    {
        type: "technology",
        id: "js",
        name: "JavaScript",
        path: jsLogo
    },
    {
        type: "technology",
        id: "react",
        name: "React",
        path: reactLogo
    },
    {
        type: "technology",
        id: "salesforce",
        name: "Salesforce",
        path: salesforceLogo
    },
        {
        type: "technology",
        id: "git",
        name: "GIT",
        path: gitLogo
    },
    {
        type: "technology",
        id: "vscode",
        name: "VS Code",
        path: vscode
    },
    {
        type: "technology",
        id: "bitbucket",
        name: "Bitbucket",
        path: bitbucket
    },
    {
        type: "technology",
        id: "azuredevops",
        name: "DevOps",
        path: azuredevops
    },
    {
        type: "technology",
        id: "confluence",
        name: "Confluence",
        path: confluence
    },
    {
        type: "technology",
        id: "jira",
        name: "Jira",
        path: jira
    },
    {
        type: "technology",
        id: "gitlab",
        name: "GitLab",
        path: gitlab
    }
    ,
    {
        type: "technology",
        id: "copado",
        name: "Copado",
        path: copado
    },
    {
        type: "technology",
        id: "github",
        name: "GitHub",
        path: github
    },
    {
        type: "technology",
        id: "node",
        name: "Node.js",
        path: node
    }
]